// 003 (FR-011; P-JOIN-10): how a join started. A link with `src=qr` (any case) is QR, any other
// link LINK; typed codes are CODE.
import type { Api } from "@/api/types";

export type JoinSource = Api["JoinSource"];

export function sourceFromLink(src: string | string[] | undefined): "LINK" | "QR" {
  return typeof src === "string" && src.toLowerCase() === "qr" ? "QR" : "LINK";
}
